import { Row, Col, Card, CardBody } from "reactstrap";
import { PacmanLoader } from "react-spinners";
import StudentResult from "../../components/Student/StudentResult";
import { GetStudentResults } from "../../actions/studentQueries";

export default function StudentResults() {
  const results = GetStudentResults();

  if (results.isPending) {
    return (
      <div
        className="sweet-loading"
        style={{ position: "fixed", top: "50%", left: "50%" }}
      >
        <PacmanLoader color={"#20a8d8"} loading={true} />
      </div>
    );
  }

  const resultList = (results.data || []).map((result, i) => (
    <Col md="3" xs="12" key={i}>
      <StudentResult result={result} />
    </Col>
  ));

  return (
    <div className="animated fadeIn">
      <Card>
        <CardBody>
          <h4>Mina bästa resultat</h4>
          <Row>{resultList}</Row>
        </CardBody>
      </Card>
    </div>
  );
}
